<template>
  <iframe
    src="/recap-league-28.html"
    class="recap-frame"
    title="LCK Split 2 2026 — 2KPI Recap"
  />
</template>

<style scoped>
.recap-frame {
  width: 100%;
  height: calc(100vh - 60px);
  border: none;
  display: block;
}
</style>
